export interface ChartDataTableColumn<T> {
    key: string;
    label: string;
    getValue: (row: T) => string;
}

interface ChartDataTableProps<T> {
    caption: string;
    columns: ChartDataTableColumn<T>[];
    rows: T[];
    rowKey: (row: T) => string;
}

export function ChartDataTable<T>({ caption, columns, rows, rowKey }: ChartDataTableProps<T>) {
    const [firstColumn, ...restColumns] = columns;

    return (
        <table className="sr-only">
            <caption>{caption}</caption>
            <thead>
                <tr>
                    {columns.map((column) => (
                        <th key={column.key} scope="col">
                            {column.label}
                        </th>
                    ))}
                </tr>
            </thead>
            <tbody>
                {rows.map((row) => (
                    <tr key={rowKey(row)}>
                        <th scope="row">{firstColumn.getValue(row)}</th>
                        {restColumns.map((column) => (
                            <td key={column.key}>{column.getValue(row)}</td>
                        ))}
                    </tr>
                ))}
            </tbody>
        </table>
    );
}
